var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"no-table-data"},[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":require('@/assets/img/no_data.jpg'),"alt":""}}),_c('p',[_vm._v("暂无数据")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }